/**
 * mediaUtils — utilitaires média partagés.
 * Encodage base64 robuste (par chunks) pour éviter les crashs sur grosses vidéos.
 */

/** Encode un Blob en base64 par chunks de 32 Ko — évite RangeError sur les grosses vidéos. */
export async function blobToBase64(blob: Blob): Promise<string> {
  const buffer = await blob.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  const CHUNK = 0x8000; // 32 Ko
  let binary = '';
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode.apply(null, Array.from(bytes.subarray(i, i + CHUNK)));
  }
  return btoa(binary);
}

export interface VideoInfo {
  mimeType: string;      // ex: 'video/webm'
  extension: string;     // ex: 'webm'
  sizeMB: number;
}

/** Retourne le vrai type MIME et l'extension d'un blob vidéo (WebM en général côté navigateur). */
export function getVideoInfo(blob: Blob): VideoInfo {
  const mimeType = blob.type || 'video/webm';
  const extension = mimeType.includes('mp4') ? 'mp4' : mimeType.includes('webm') ? 'webm' : 'webm';
  return { mimeType, extension, sizeMB: +(blob.size / (1024 * 1024)).toFixed(2) };
}
